<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <app-ds-icon name="close-x" size="icon-size-2" color="var(--color-core-neutral-7)"></app-ds-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<div class="modal-content">
  <h1 class="ds-title-4">{{ 'GROW.performance.cny.title' | translate }}</h1>
  <!-- Net Yield -->
  <div class="breakdown-header">
    <div>
      <h2 class="ds-heading-2">{{ 'GROW.performance.cny.total.title' | translate }}</h2>
      <app-ds-icon name="info" class="info-icon" color="var(--color-core-neutral-5)" (click)="onShowInfo('currentNetYield')"></app-ds-icon>
    </div>
    @if (info['currentNetYield']) {
      @for (paragraph of [1, 2, 3, 4]; track paragraph) {
        <p class="ds-ui-3 ds-color-core-neutral-7" [innerHTML]="'GROW.performance.cny.total.p' + paragraph | translate"></p>
      }
    }
  </div>
  <div class="breakdown-content">
    <app-ds-info-row [showCustomContent]="true">
      <ng-template #customContent>
        <div class="project-title">
          <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'GROW.performance.cny.total.weightedBond' | translate }}</p>
        </div>

        <div class="project-values">
          <p class="ds-ui-2">
            {{ overview.annual_return.bond_rate | percent: '1.2-2' }}
            {{ 'GROW.project.perAnnum' | translate }}
          </p>
        </div>
      </ng-template>
    </app-ds-info-row>

    <app-ds-info-row [showCustomContent]="true">
      <ng-template #customContent>
        <div class="project-title">
          <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'GROW.performance.cny.total.notInvested' | translate }}</p>
        </div>

        <div class="project-values">
          <p class="ds-ui-2">
            {{ overview.annual_return.cash_effect | percent: '1.2-2' }}
            {{ 'GROW.project.perAnnum' | translate }}
          </p>
        </div>
      </ng-template>
    </app-ds-info-row>

    <app-ds-info-row [showCustomContent]="true">
      <ng-template #customContent>
        <div class="project-title">
          <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'GROW.performance.cny.total.fees' | translate }}</p>
        </div>

        <div class="project-values">
          <p class="ds-ui-2">
            {{ overview.annual_return.scaled_fee | percent: '1.2-2' }}
            {{ 'GROW.project.perAnnum' | translate }}
          </p>
        </div>
      </ng-template>
    </app-ds-info-row>

    <app-ds-info-row
      [showCustomContent]="true"
      [customStyle]="'background-color: var(--color-core-brand-3-2); border-top: medium none; padding-left: var(--spacing-3); padding-right: var(--spacing-3); border-radius: var(--spacing-2); margin-top: var(--spacing-4);'"
    >
      <ng-template #customContent>
        <div class="project-title">
          <p class="ds-caption-1 ds-color-core-neutral-7">{{ 'GROW.performance.cny.total.netYield' | translate }}</p>
        </div>

        <div class="project-values">
          <p class="ds-caption-1">{{ overview.annual_return.net_invested_only | percent: '1.2-2' }} {{ 'GROW.project.perAnnum' | translate }}</p>
        </div>
      </ng-template>
    </app-ds-info-row>
  </div>

  @if (filteredInvestments.length > 0) {
    <!-- Breakdown  -->
    <div class="breakdown-header">
      <div>
        <h2 class="ds-heading-2">{{ 'GROW.performance.cny.breakdown.title' | translate }}</h2>
        <app-ds-icon name="info" class="info-icon" color="var(--color-core-neutral-5)" (click)="onShowInfo('breakdown')"></app-ds-icon>
      </div>
      @if (info['breakdown']) {
        <p class="ds-ui-3 ds-color-core-neutral-7">{{ 'GROW.performance.cny.breakdown.p1' | translate }}</p>
      }
    </div>

    <div class="breakdown-content">
      <app-ds-info-row [showCustomContent]="true"  [customStyle]="'border-top: medium none;'">
        <ng-template #customContent>
          <div class="project-yield-title"></div>

          <div class="project-yield-breakdown">
            <p class="ds-caption-3 ds-color-core-neutral-7">
              {{ 'GROW.performance.cny.breakdown.weight' | translate | uppercase }}
            </p>
            <p class="ds-caption-3 ds-color-core-neutral-7">
              {{ 'GROW.performance.cny.breakdown.rate' | translate | uppercase }}
            </p>
          </div>
        </ng-template>
      </app-ds-info-row>
      @for (investment of filteredInvestments; track investment.impact_project_id) {
        <app-ds-info-row [showCustomContent]="true">
          <ng-template #customContent>
            <div class="project-yield-title">
              <p class="ds-ui-2 ds-color-core-neutral-7">{{ investment.impact_project_title }}</p>
            </div>

            <div class="project-yield-breakdown">
              <p class="ds-ui-3 ds-color-core-neutral-7">
                {{ investment.weight | percent: '1.2-2' }}
              </p>
              <p class="ds-ui-2 ds-color-core-neutral-10">
                {{ investment.annual_return | percent: '1.2-2' }} {{ 'GROW.project.perAnnum' | translate }}
              </p>
            </div>
          </ng-template>
        </app-ds-info-row>
      }

      <app-ds-info-row
        [showCustomContent]="true"
        [customStyle]="'background-color: var(--color-core-brand-3-2); border-top: medium none; padding-left: var(--spacing-3); padding-right: var(--spacing-3); border-radius: var(--spacing-2); margin-top: var(--spacing-4);'"
      >
        <ng-template #customContent>
          <div class="project-title">
            <p class="ds-caption-1 ds-color-core-neutral-7">{{ 'GROW.performance.cny.breakdown.average' | translate }}</p>
          </div>

          <div class="project-values">
            <p class="ds-caption-1">{{ overview.annual_return.bond_rate | percent: '1.2-2' }} {{ 'GROW.project.perAnnum' | translate }}</p>
          </div>
        </ng-template>
      </app-ds-info-row>
    </div>
  }
</div>
